import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import theme from '../constants/theme'
import { FooterContent, MainContainer, NotificationBox } from './styled'
import PrimaryButton from './buttons/PrimaryButton'
import CheckOne from '../assets/svgs/checkOne'
import ExclamationCircle from '../assets/svgs/exclamationCircle'
import Frown from '../assets/svgs/frown'
import useDeviceType from '../hooks/useDeviceType'

function NotificationBoxPage({
  messageType,
  message,
  rescheduleInterview,
  rescheduleEnabled,
  isFinished,
  isExpired,
  children,
}) {
  const { t } = useTranslation()
  const deviceType = useDeviceType()
  const isMobile = deviceType !== 'desktop'

  const renderMessage = (type) => {
    const iconSize = isMobile ? '36px' : '48px'

    let messageIcon = <CheckOne width={iconSize} height={iconSize} />
    let messageColor = theme.talentinoGreen

    switch (type) {
      case 'success':
        messageIcon = <CheckOne width={iconSize} height={iconSize} />
        messageColor = theme.talentinoGreen
        break
      case 'error':
        messageIcon = <Frown width={iconSize} height={iconSize} />
        messageColor = theme.talentinoDarkerRed
        break
      case 'warning':
        messageIcon = (
          <ExclamationCircle
            width={iconSize}
            height={iconSize}
            color={theme.talentinoWarning}
          />
        )
        messageColor = theme.talentinoWarning
        break
      default:
        messageIcon = <CheckOne width={iconSize} height={iconSize} />
        messageColor = theme.talentinoBlue
        break
    }

    return (
      <NotificationBox
        color={messageColor}
        minWidth={isMobile ? '90%' : undefined}
        style={{
          padding: isMobile ? '25px 15px' : '40px',
          maxWidth: isMobile ? '95%' : undefined,
        }}
      >
        {messageIcon}
        <p
          style={{
            fontSize: isMobile ? '18px' : '20px',
            whiteSpace: 'pre-line',
            textAlign: 'center',
          }}
        >
          {message}
        </p>
      </NotificationBox>
    )
  }

  return (
    <MainContainer backgroundColor={theme.talentinoSkyBlue}>
      <div
        className="d-flex flex-column justify-content-center align-items-center w-100 h-100 p-3"
        style={{ flexGrow: 1 }}
      >
        {renderMessage(messageType)}
        {rescheduleEnabled && !isFinished && isExpired && (
          <PrimaryButton
            color={theme.talentinoSpecialBlue}
            backgroundcolor={theme.talentinoWhiteBlue}
            hovercolor={theme.talentinoDarkerWhiteBlue}
            onClick={rescheduleInterview}
            style={{
              fontSize: isMobile ? '14px' : '16px',
              padding: isMobile ? '5px 15px' : '5px 40px',
            }}
          >
            {t('preInterview.rescheduleInterview')}
          </PrimaryButton>
        )}
        {children}
        <div
          className="fixed-bottom"
          style={{
            marginLeft: isMobile ? '10px' : '30px',
            marginBottom: isMobile ? '10px' : '30px',
            display: 'inline-flex',
            padding: isMobile ? '10px' : '15px',
          }}
        >
          <p
            style={{
              color: theme.talentinoDarkerGray,
              fontSize: isMobile ? '11px' : '13px',
              fontWeight: '400',
            }}
          >
            <span style={{ fontWeight: '600' }}>
              {' '}
              {t('footer.TalentinoAI')}{' '}
              <FooterContent>© {new Date().getFullYear()}</FooterContent>
            </span>
            .{' '}
            <span style={{ fontWeight: '600' }}>
              {t('footer.allRightsReserved')}
            </span>
          </p>
        </div>
      </div>
    </MainContainer>
  )
}

export default NotificationBoxPage

NotificationBoxPage.propTypes = {
  messageType: PropTypes.string,
  message: PropTypes.string,
  rescheduleInterview: PropTypes.func,
  rescheduleEnabled: PropTypes.bool,
  isFinished: PropTypes.bool,
  isExpired: PropTypes.bool,
  children: PropTypes.node,
}

NotificationBoxPage.defaultProps = {
  messageType: 'error',
  message: '',
  rescheduleInterview: () => {},
  rescheduleEnabled: false,
  isFinished: false,
  isExpired: false,
  children: null,
}
